import { useState, useRef, useEffect, useCallback } from 'react';

export function useCompactMenu() {
    const [isCompactView, setIsCompactView] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= 960 : false
    );
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeDrawer, setActiveDrawer] = useState(null); // 'templates' | 'datafields' | null

    const menuRef = useRef(null);

    // Close menu popover on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsMenuOpen(false);
            }
        };
        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);

    // Track window resize for compact mode
    useEffect(() => {
        const handleResize = () => {
            const compact = window.innerWidth <= 960;
            setIsCompactView(compact);
            if (!compact) {
                setActiveDrawer(null);
                setIsMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return { isCompactView, isMenuOpen, setIsMenuOpen, activeDrawer, setActiveDrawer, menuRef };
}
